enum CategoryImageType {
  logo = 1,
}

export default CategoryImageType;
